import React, { useState } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import ReactSlider from 'react-slider'
import { AnimatePresence, motion } from 'framer-motion'
import { ChevronDownIcon } from 'components'

const fadeIn = {
  variants: {
    hidden: { opacity: 0, y: '-20px' },
    visible: { opacity: 1, y: 0 },
  },
  initial: 'hidden',
  animate: 'visible',
  exit: 'hidden',
  transition: { duration: 0.3, ease: 'easeInOut' },
}

const Slider = ({ value, minValue, maxValue, defaultValue, label, icon, className, onChange }) => {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <motion.div
      layout
      className={classnames('relative rounded-3xl px-7 overflow-hidden', className)}
    >
      <button
        className="relative bg-transparent block w-full text-left"
        type="button"
        onClick={() => setIsOpen(!isOpen)}
      >
        {icon}
        <div
          className={classnames('border-0 py-5 text-base', {
            'pl-12': icon,
          })}
        >
          {label}
        </div>
        <ChevronDownIcon
          className={classnames(
            'w-4 h-4 absolute -right-1 top-1/2 transform -translate-y-1/2 transition-transform pointer-events-none text-white',
            {
              'rotate-180': isOpen,
            }
          )}
        />
      </button>
      <AnimatePresence>
        {isOpen && (
          <motion.div {...fadeIn}>
            <ReactSlider
              className="pt-4 pb-7"
              thumbClassName="bg-emperorGray h-6 w-6 transform -translate-y-1/2 rounded-full cursor-pointer"
              trackClassName="bg-emperorGray h-1"
              ariaLabel={['Lower thumb', 'Upper thumb']}
              ariaValuetext={state => `Thumb value ${state.valueNow}`}
              min={minValue}
              max={maxValue}
              defaultValue={defaultValue}
              value={value}
              onChange={values => onChange(values)}
              minDistance={1}
              pearling
            />
          </motion.div>
        )}
      </AnimatePresence>
    </motion.div>
  )
}

Slider.propTypes = {
  minValue: PropTypes.number,
  maxValue: PropTypes.number,
  defaultValue: PropTypes.oneOfType([PropTypes.number, PropTypes.array]),
  value: PropTypes.any,
  className: PropTypes.string,
  icon: PropTypes.object,
  onChange: PropTypes.func,
  label: PropTypes.any,
}

export default Slider
